import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import PhoneNumberInput from 'components/inputs/PhoneNumberInput';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_USER } from 'actions/user';
import { FETCH_OPERATOR_MASTER } from 'actions/operatorMaster';
import Select from 'components/inputs/Select';
import * as _ from 'lodash';

const ContactInfo = ({ formData, setFormData, setIsStepValid }) => {
  const { t } = useTranslation();
  const [phoneError, setPhoneError] = useState('');
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.user.users) || [];
  const operatorList = useSelector((state) => state.operatorMaster?.operatorMasters || []);

  useEffect(() => {
    dispatch({ type: FETCH_USER.REQUEST, payload: { role: 'ZMT', limit: 999 } });
    dispatch({ type: FETCH_OPERATOR_MASTER.REQUEST, payload: { limit: 999 } });
  }, [dispatch]);

  useEffect(() => {
    setIsStepValid(true);
    setFormData((prev) => ({
      ...prev,
      contact_phone: prev.contact_phone || '',
    }));
  }, [setIsStepValid, setFormData]);

  const handlePhoneChange = (value) => {
    if (!value) {
      setPhoneError('Phone number is required');
      return;
    }
  
    // Remove "+91" if user enters it manually to avoid duplication
    let rawNumber = value.replace(/^\+91/, '').trim();
  
    setFormData((prev) => ({
      ...prev,
      contact_phone: rawNumber, // Store only raw number
    }));
  
    if (phoneError) {
      setPhoneError('');
    }
  };
  

  return (
    <div className="space-y-4">
      <h5 className="text-xl font-semibold mb-4">{t('addStationForm.owner/contactPerson')}</h5>
      <Row>
        <Col lg={6} md={12}>
          <Select
            label="ZME Name"
            options={_.map(allUsers, (item) => {
              return { label: item.name, value: item.id || item._id };
            })}
            placeholder="Select ZME"
            name="contact_person"
            value={formData.contact_person?.id || formData.contact_person?._id || formData.contact_person || ''}
            onChange={(val) => setFormData({ ...formData, contact_person: val })}
          />
        </Col>

        <Col lg={6} md={12}>
          <Select
            label="Operator Master"
            placeholder="Select Operator"
            name="operatorMaster"
            options={operatorList.map((item) => ({
              label: item.name,
              value: item._id || item.id,
            }))}
            isClearable={true}
            value={
              typeof formData.operatorMaster === 'object'
                ? (formData.operatorMaster?.id || formData.operatorMaster?._id)
                : (formData.operatorMaster || (typeof formData.operator_master === 'object' ? (formData.operator_master?.id || formData.operator_master?._id) : formData.operator_master) || '')
            }
            onChange={(val) => setFormData({ ...formData, operatorMaster: val || '' })}
          />
        </Col>

        <Col lg={6} md={12}>
          <TextInput
            label={t('addStationForm.name')}
            name="contact_name"
            value={formData.contact_name || ''}
            onChange={(e) => setFormData({ ...formData, contact_name: e.target.value })}
          />
        </Col>

        <Col lg={6} md={12}>
          <PhoneNumberInput
            label={t('addStationForm.phoneNumber')}
            name="contact_phone"
            value={`+91${formData.contact_phone || ''}`} // Always show +91

            onChange={handlePhoneChange}
            error={phoneError}
          />
        </Col>

        <Col lg={6} md={12}>
          <TextInput
            label={t('addStationForm.emailAddress')}
            name="contact_email"
            value={formData.contact_email || ''}
            onChange={(e) => setFormData({ ...formData, contact_email: e.target.value })}
          />
        </Col>

        <Col lg={6} md={12}>
          <TextInput
            label={t('addStationForm.officeAddress')}
            name="contact_address"
            value={formData.contact_address || ''}
            onChange={(e) => setFormData({ ...formData, contact_address: e.target.value })}
          />
        </Col>
      </Row>
    </div>
  );
};

ContactInfo.propTypes = {
  formData: PropTypes.shape({
    contact_name: PropTypes.string,
    contact_phone: PropTypes.string,
    contact_email: PropTypes.string,
    contact_address: PropTypes.string,
    contact_person: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    operatorMaster: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    operator_master: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
};

export default ContactInfo;